export const getLinkRel = (target = '') => {
  if (target === '_blank') {
    return 'nofollow noopener noreferrer'
  }
  return ''
}
